import { Table } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { CustomTable } from "../../../../../../../components";
import { moneyFormat } from "../../../../../../../plugins/numberFormat";
import { getCurrency } from "../../../../../../../plugins/utils";
import { useComission } from "../../../../context/ComissionContext";
import { useGetLevelBonus } from "../../../../hooks/comissionreport.hooks";
import styles from "./style.module.scss";

const Level = ({ level = null }) => {
  const { t } = useTranslation();
  const nowCurrency = getCurrency();
  const { selectedMonth, agentBonusId, selectedWeek } = useComission();
  const { data, hasNextPage, isFetchingNextPage, fetchNextPage, isLoading, isError } =
    useGetLevelBonus({
      params: {
        // period_month: selectedMonth.value,
        period_date: selectedWeek?.value?.split("~")[0],
      },
      level: level,
      agent_bonus_id: agentBonusId,
      options: {
        enabled: level !== null && selectedWeek !== null && agentBonusId !== null,
        getNextPageParam: (lastPage, pages) => {
          if (pages.length < lastPage.last_page) {
            return pages.length + 1;
          } else {
            return undefined;
          }
        },
      },
    });

  const [summary, setSummary] = useState(0);
  const [localData, setLocalData] = useState([]);

  const columns = [
    {
      title: t("comission.table.account"),
      width: 100,
      align: "center",
      dataIndex: "account",
    },

    {
      title: t("comission.table.UID"),
      width: 100,
      align: "center",
      dataIndex: "account_id",
    },
    {
      title: t("comission.table.levelBonus") + `(${t(`global.currency.${nowCurrency}`)})`,
      width: 100,
      align: "center",
      dataIndex: "level_bonus_amount",
      render: (text, record, index) => (
        <div className={`${styles.amount} ${text <= 0 ? styles.redColor : styles.greenColor}`}>
          {moneyFormat(text)}
        </div>
      ),
    },
  ];

  const loadMore = () => {
    if (isFetchingNextPage === false && localData.length > 0) {
      fetchNextPage();
    }
  };

  useEffect(() => {
    if (data) {
      const page_length = data.pages.length;
      if (page_length <= 1) {
        setLocalData([...data.pages[0].data]);
      } else {
        setLocalData((prevState) => {
          return [...prevState, ...data.pages[page_length - 1].data];
        });
      }
      const totalBonus = data.pages[page_length - 1].data.reduce(
        (sum, a) => sum + (a.level_bonus_amount || 0),
        0,
      );
      setSummary(totalBonus);
    }
  }, [data]);

  const onHandleSearch = () => {};

  return (
    <div className={styles.container}>
      {isError ? (
        ""
      ) : (
        <CustomTable
          columns={columns}
          dataSource={localData}
          hasMore={hasNextPage}
          loadMore={loadMore}
          showInifineScroll={true}
          summary={() => {
            return (
              <Table.Summary fixed="top">
                <Table.Summary.Row>
                  <Table.Summary.Cell index={0}>
                    <div className={styles.summaryCell}>{t("normal.summary")}</div>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={1} />
                  <Table.Summary.Cell index={2}>
                    <div
                      className={`${styles.summaryCell} ${styles.content} ${
                        summary <= 0 ? styles.redColor : styles.greenColor
                      }`}
                    >
                      {moneyFormat(summary || 0)}
                    </div>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={3} />
                </Table.Summary.Row>
              </Table.Summary>
            );
          }}
        />
      )}
    </div>
  );
};

export default Level;
